module.exports = __webpack_public_path__ + "img/a218_reset.60ce76cc.png";